import { faqData } from '@/mocks/home';
import { useState } from 'react';

export default function FaqSection() {
  const [openId, setOpenId] = useState(1);

  const toggleFaq = (id: number) => {
    setOpenId(openId === id ? 0 : id);
  };

  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[800px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-500/10 border border-primary-500/20 text-xs font-medium text-primary-400 mb-3">
            <i className="ri-question-answer-line"></i>
            答疑解惑
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">常见问题</h2>
        </div>

        <div className="flex flex-col gap-3">
          {faqData.map((item) => (
            <div
              key={item.id}
              className="rounded-2xl bg-background-100 border border-background-200/60 overflow-hidden transition-all duration-300"
            >
              <button
                onClick={() => toggleFaq(item.id)}
                className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
              >
                <h3 className="text-sm font-semibold text-foreground-800 pr-2">{item.question}</h3>
                <div className={`w-6 h-6 flex items-center justify-center rounded-full transition-all duration-300 flex-shrink-0 ${
                  openId === item.id ? 'bg-primary-500/15 rotate-180' : 'bg-background-200/50'
                }`}>
                  <i className="ri-arrow-down-s-line text-sm text-foreground-500"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openId === item.id ? 'max-h-60 pb-4 px-5' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-500 leading-relaxed">{item.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}